(function () {
  if (window.__spsQuickBuyBound) return;
  window.__spsQuickBuyBound = true;

  var COLOR_HEX = {
    "Black / Dark Teal": "#17506b",
    "Pink / Pink": "#f7b8cd",
    "Aqua / Black": "#bfe8dc"
  };

  var selectedVariantId = null;
  var qty = 1;

  function moneyHtml(value) {
    if (value == null || value === "" || value === "—") return "—";
    var text = String(value);
    if (text.indexOf('class="money"') !== -1 || text.indexOf("class='money'") !== -1 || text.indexOf("class=money") !== -1) {
      return text;
    }
    return '<span class="money">' + text + "</span>";
  }

  function setMoneyEl(el, value) {
    if (!el) return;
    var html = moneyHtml(value);
    if (html === "—") el.textContent = "—";
    else el.innerHTML = html;
  }

  function productsEl() {
    return document.querySelector("[data-sps-products]");
  }

  function loadProducts() {
    var el = productsEl();
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return {};
    }
  }

  function modalEl() {
    return document.getElementById("spsQuickBuy");
  }

  function mountModal() {
    var modal = modalEl();
    if (modal && modal.parentElement !== document.body) {
      modal.classList.add("sps");
      document.body.appendChild(modal);
    }
    return modalEl();
  }

  function openQuickBuy(key) {
    var modal = mountModal();
    if (!modal) return;

    var titleEl = document.getElementById("spsQbTitle");
    var fitsEl = document.getElementById("spsQbFits");
    var swatchesEl = document.getElementById("spsQbSwatches");
    var qtyEl = document.getElementById("spsQbQty");
    var priceEl = document.getElementById("spsQbPrice");
    var addBtn = document.getElementById("spsQbAdd");
    if (!titleEl || !fitsEl || !swatchesEl || !qtyEl || !priceEl || !addBtn) return;

    var catalog = loadProducts();
    var product = catalog[key] || {};
    selectedVariantId = null;
    qty = 1;
    qtyEl.textContent = qty;
    titleEl.textContent = product.title || "—";
    fitsEl.textContent = product.fits || "";
    setMoneyEl(priceEl, "—");
    addBtn.disabled = true;
    addBtn.textContent = "Select a colour";

    swatchesEl.innerHTML = "";
    var variants = product.variants || [];
    variants.forEach(function (v) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sps-qb__swatch";
      if (!v.available) btn.disabled = true;
      var dot = document.createElement("span");
      dot.className = "dot";
      dot.style.background = COLOR_HEX[v.color] || "#ccc";
      btn.appendChild(dot);
      btn.appendChild(document.createTextNode(v.color || "Option"));
      btn.addEventListener("click", function () {
        selectedVariantId = v.id;
        Array.prototype.forEach.call(swatchesEl.children, function (b) {
          b.classList.toggle("on", b === btn);
        });
        setMoneyEl(priceEl, v.price_html);
        addBtn.disabled = false;
        addBtn.textContent = "Add to cart";
      });
      swatchesEl.appendChild(btn);
    });

    if (!variants.length) {
      addBtn.textContent = "Product unavailable";
    }

    var cardBtn = document.querySelector('[data-quickbuy="' + key + '"]');
    var shownCap = cardBtn && cardBtn.closest(".sps-card") && cardBtn.closest(".sps-card").querySelector(".sps-carousel figure.on figcaption");
    if (shownCap) {
      var shownName = shownCap.textContent.trim();
      Array.prototype.forEach.call(swatchesEl.children, function (b, k) {
        if (variants[k] && variants[k].color === shownName && !b.disabled) b.click();
      });
    }

    modal.classList.add("on");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeQuickBuy() {
    var modal = modalEl();
    if (!modal) return;
    modal.classList.remove("on");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var buyBtn = e.target.closest("[data-quickbuy]");
    if (buyBtn) {
      e.preventDefault();
      openQuickBuy(buyBtn.getAttribute("data-quickbuy"));
      return;
    }
    var colorBtn = e.target.closest("[data-sps-color]");
    if (colorBtn) {
      var card = colorBtn.closest(".sps-card");
      var figs = card ? card.querySelectorAll(".sps-carousel figure") : [];
      var cdots = card ? card.querySelectorAll(".sps-cdots button") : [];
      Array.prototype.forEach.call(figs, function (f, k) {
        var cap = f.querySelector("figcaption");
        if (cap && cap.textContent.trim() === colorBtn.getAttribute("data-sps-color") && cdots[k]) cdots[k].click();
      });
      return;
    }
    if (e.target.closest("[data-qb-close]")) {
      closeQuickBuy();
      return;
    }
    var qtyBtn = e.target.closest("[data-qb-qty]");
    if (qtyBtn && modalEl() && modalEl().contains(qtyBtn)) {
      var delta = parseInt(qtyBtn.getAttribute("data-qb-qty"), 10);
      qty = Math.max(1, Math.min(10, qty + delta));
      var qtyEl = document.getElementById("spsQbQty");
      if (qtyEl) qtyEl.textContent = qty;
      return;
    }
    if (e.target.id === "spsQbAdd" || (e.target.closest && e.target.closest("#spsQbAdd"))) {
      var addBtn = document.getElementById("spsQbAdd");
      if (!addBtn || addBtn.disabled || !selectedVariantId) return;
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return res.json();
        })
        .then(function () {
          window.location.href = root + "checkout";
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = "Something went wrong — try again";
        });
    }
  });

  document.addEventListener("keydown", function (e) {
    var modal = modalEl();
    if (e.key === "Escape" && modal && modal.classList.contains("on")) closeQuickBuy();
  });

  function initPricingAndCarousels() {
    if (window.__spsPricingBound) return;
    window.__spsPricingBound = true;

    document.querySelectorAll(".sps-carousel").forEach(function (car) {
      if (car.getAttribute("data-sps-ready")) return;
      car.setAttribute("data-sps-ready", "true");
      var figs = Array.prototype.slice.call(car.querySelectorAll("figure"));
      var dots = car.querySelector(".sps-cdots");
      var prev = car.querySelector(".prev");
      var next = car.querySelector(".next");
      if (!dots || !prev || !next || !figs.length) return;
      var i = Math.max(
        0,
        figs.findIndex(function (f) {
          return f.classList.contains("on");
        })
      );
      figs.forEach(function (_, n) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Show color " + (n + 1));
        b.addEventListener("click", function () {
          go(n);
        });
        dots.appendChild(b);
      });
      function go(n) {
        i = (n + figs.length) % figs.length;
        figs.forEach(function (f, k) {
          f.classList.toggle("on", k === i);
        });
        Array.prototype.forEach.call(dots.children, function (d, k) {
          d.classList.toggle("on", k === i);
        });
        var cap = figs[i].querySelector("figcaption");
        var cardEl = car.closest(".sps-card");
        if (cap && cardEl) {
          Array.prototype.forEach.call(cardEl.querySelectorAll("[data-sps-color]"), function (cb) {
            cb.classList.toggle("on", cb.getAttribute("data-sps-color") === cap.textContent.trim());
          });
        }
      }
      prev.addEventListener("click", function () {
        go(i - 1);
      });
      next.addEventListener("click", function () {
        go(i + 1);
      });
      go(i);
    });
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function markSoldOutColours() {
    var catalog = loadProducts();
    Object.keys(catalog).forEach(function (key) {
      var btn = document.querySelector('[data-quickbuy="' + key + '"]');
      var card = btn && btn.closest(".sps-card");
      if (!card) return;
      (catalog[key].variants || []).forEach(function (v) {
        if (v.available) return;
        Array.prototype.forEach.call(card.querySelectorAll("[data-sps-color]"), function (cb) {
          if (cb.getAttribute("data-sps-color") === v.color) {
            cb.classList.add("sold");
            cb.setAttribute("aria-label", "Show " + v.color + " (sold out)");
          }
        });
      });
    });
  }

  ready(function () {
    mountModal();
    markSoldOutColours();
    initPricingAndCarousels();
  });
  document.addEventListener("shopify:section:load", mountModal);
})();
